<template lang="pug">
.qa-and-suggest-contioner
  .button-container(v-if="freeRightsVersion()")
    .button-qa-or-suggest(@click="goSuggest") 建议反馈
    .button-qa-or-suggest(@click="goQa") 常见问题
  .qa-and-suggest(v-else)
    .suggest-block(@click="goSuggest")
      .suggest-title
        div 会员权益建议
        .qa-go
          img(src="https://m.hellobike.com/resource/helloyun/08345/gi6zaIMKbj.png")
      .suggest-word 期待您的反馈
    .qa-block(v-if="this.showQa" @click="goQa")
      .qa-left
        .qa-title
          .qa-title-word 对超级会员有疑问
          .qa-go
            img(src="https://m.hellobike.com/resource/helloyun/08345/gi6zaIMKbj.png")
        .qa-word 查看常见问题
  </template>
<script>
export default {
  props: {
    showQa: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['freeRightsVersion'], // 从父组件注入freeRightsVersion
  methods: {
    goQa() {
      this.$emit('goQa');
    },
    goSuggest() {
      this.$emit('goSuggest');
    },
  },
};
</script>
<style lang="less" scoped>
.qa-and-suggest-contioner {
  .qa-and-suggest {
    display: flex;
    justify-content: flex-start;
    margin: 0.08rem 0.12rem 0.2rem 0.12rem;
    height: 0.69rem;

    .suggest-block {
      background: #fff;
      border-radius: 0.12rem;
      padding: 0.14rem 0 0 0.12rem;
      height: 100%;
      width: 1.72rem;

      .suggest-title {
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 0.16rem;
        color: #242729;
        font-weight: 500;
        margin-bottom: 0.05rem;
        display: flex;

        .qa-go {
          img {
            width: 0.15rem;
            height: 0.15rem;
          }
        }
      }

      .suggest-word {
        margin-top: 0.04rem;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 0.14rem;
        color: #879099;
        font-weight: 400;
      }
    }

    .qa-block {
      background: #fff;
      border-radius: 0.12rem;
      display: flex;
      justify-content: space-between;
      padding: 0.14rem 0 0 0.12rem;
      height: 100%;
      width: 1.71rem;
      margin-left: 0.08rem;

      .qa-left {
        .qa-title {
          font-family: PingFangSC-Medium, sans-serif;
          font-size: 0.16rem;
          color: #242729;
          font-weight: 500;
          margin-bottom: 0.05rem;
          display: flex;

          .qa-go {
            img {
              width: 0.15rem;
              height: 0.15rem;
            }
          }
        }

        .qa-word {
          margin-top: 0.04rem;
          font-family: PingFangSC-Regular, sans-serif;
          font-size: 0.14rem;
          color: #879099;
          font-weight: 400;
        }
      }
    }
  }
}

.free-rights-version {
  .qa-and-suggest-contioner {
    width: 3.75rem;
    height: 1.975rem;
    margin-top: 0.3rem;
    background: url('https://assets.51downapp.cn/file-1754654286653-445078346.png');
    background-size: 100% auto;
    background-position: bottom;
    background-repeat: no-repeat;

    .button-container {
      width: 2.08rem;
      height: 0.32rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .button-qa-or-suggest {
        /* border: 0.01rem solid #000; */
        width: 0.94rem;
        height: 0.32rem;
        flex-shrink: 0;
        border-radius: 0.34rem;
        opacity: 0.5;
        background: #fff;
        color: #242729;
        text-align: center;
        font-family: "PingFang SC", sans-serif;
        font-size: 0.12rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.32rem;
      }
    }
  }
}
</style>
